import { storeToRefs } from 'pinia';

import { generateDeviceFingerprintHandler } from '~/handlers/generate-device-fingerprint';
import { useDeviceStore } from '~/stores/apostatudo/device';

export const useDeviceFingerprint = () => {
  const deviceStore = useDeviceStore();
  const { fingerprint } = storeToRefs(deviceStore);
  const { isNativeApp } = useAppTrackingPolicy();

  const ensureFingerprint = async () => {
    // Dentro do app não geramos device fingerprint (a Apple proíbe o
    // fingerprinting mesmo first-party — ENG-397 / App Store 5.1.1(iv)).
    if (isNativeApp) {
      return null;
    }

    if (fingerprint.value) {
      return fingerprint.value;
    }

    if (!import.meta.client) {
      return fingerprint.value;
    }

    const generatedFingerprint = await generateDeviceFingerprintHandler();

    if (generatedFingerprint) {
      deviceStore.setFingerprint(generatedFingerprint);

      return generatedFingerprint;
    }

    return fingerprint.value;
  };

  return {
    fingerprint,
    ensureFingerprint,
  };
};
